import React from "react";

const ProfilePicture = ({ photo, name, onEdit, onPhotoChange }) => {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      {/* Profile Image Section */}
      <label htmlFor="photoUpload">
        <img
          src={photo}
          alt="Profile"
          className="profile-picture"
          style={{
            borderRadius: "50%",
            width: "150px",
            height: "150px",
            objectFit: "cover",
            marginBottom: "10px",
            cursor: "pointer", // Indicates the image is clickable
          }}
        />
      </label>
      <input
        type="file"
        id="photoUpload"
        accept="image/*"
        style={{ display: "none" }}
        onChange={onPhotoChange} // Call onPhotoChange when user selects an image
      />

      {/* Name */}
      <h2 style={{ color: "#dbd9d1" }}>{name}</h2>

      {/* Edit Profile Button */}
      <button
        onClick={onEdit}
        style={{
          backgroundColor: "#dbd9d1",
          padding: "10px 20px",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "10px",
          fontWeight: "bold",
        }}
      >
        Edit Profile
      </button>
    </div>
  );
};

export default ProfilePicture;
